<template>
  <div class="collapse">
    <div class="collapse-header" @click.stop.prevent="toggle">
      <div class="collapse-header-left">
        <slot name="prefix" @click.native.stop></slot>
        <span class="md-body-2">
        {{title}}
        </span>
      </div>
      <div class="collapse-header-right">
        <slot class="collapse-header-right-content" name="header"/>
        <button class="md-button md-icon-button md-dense">
          <i class="md-icon" :class="{active: active}">keyboard_arrow_down</i>
        </button>
      </div>
    </div>
    <transition name="fade" :duration="{ enter: 500, leave: 0 }">
      <div class="collapse-content" v-show="active"><slot/></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  inject: ['$validator'],
  props: {
    title: String,
    activeCreated: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    active: false
  }),
  methods: {
    toggle () {
      this.active = !this.active
      this.$emit('update:active', this.active)
      this.$emit('toggle', this)
    }
  },
  mounted () {
    this.active = this.activeCreated
  }
}
</script>

<style lang="scss" scoped>
  .collapse {
    width: 100%;
    .collapse-header {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      border-top: 1px solid #e1e1e1;
      padding: 6px 15px 6px 15px;
      .md-icon{
        margin: 0px;
      }

      i {
        transition: transform 200ms ease;

        &.active {
          transform: rotateZ(180deg);
        }
      }

      .collapse-header-right {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .collapse-header-left{
        display: flex;
        align-items: center;
        gap: 0;
        white-space: nowrap;
        overflow: hidden;

        ::v-deep .md-checkbox {
          margin: 6px 12px 6px 0px;
        }

        span {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .collapse-content {
      padding: 0px 24px 8px 24px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }

</style>
